import supabase from '../supabaseClient';
import { clearAuth } from '../store/authSlice';
import { clearDraft, clearLocalDraft } from './applicationDraft';

export async function signOutUser({ dispatch, navigate, userId }) {
  clearDraft(userId);
  clearLocalDraft(userId);
  await supabase.auth.signOut();
  dispatch(clearAuth());
  navigate('/');
}
